import { render } from "./CustomScrollbar.vue?vue&type=template&id=1da34d81&scoped=true"
import script from "./CustomScrollbar.vue?vue&type=script&lang=js"
export * from "./CustomScrollbar.vue?vue&type=script&lang=js"

import "./CustomScrollbar.vue?vue&type=style&index=0&id=1da34d81&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da34d81"]])

export default __exports__